import { ISelectMultiOption, ISelectOption } from '@salecycle/ui-component-library';
import { sortOptions } from '../../core/ui/utils/sorting';
import { IApiEntity } from 'entities/entity';
import { TFunction } from 'i18next';

// takes array of strings and returns alphabetically sorted array of ISelectOption for UI drop downs
export function getSortedSelectOptionsForStringNames(names: string[]): ISelectOption<string>[] {
  return names
    ?.map((name: string) => ({
      value: name,
      label: name,
    }))
    .sort(sortOptions);
}

// Convents an array of objects that implement IApiEntity to an array of ISelectOption sorted by entity name
export function entityToSortedSelectOptions<T extends IApiEntity>(entities: T[]): ISelectOption<string>[] {
  return entities
    ?.map((client: T) => ({
      value: client.id,
      label: client.name,
    }))
    .sort(sortOptions);
}

// Convents an array of objects that implement IApiEntity to an array of ISelectOption where name is translated
export function entityToTranslatedSelectOptions<T extends IApiEntity>(
  entities: T[],
  t: TFunction,
): ISelectOption<string>[] {
  return entities.map(x => {
    return {
      value: x.id,
      label: t(`${x.name}`),
    };
  });
}

// Convents an array of objects that implement IApiEntity to an array of ISelectOption where name is translated
export function entityToTranslatedMultiSelectOptions<T extends IApiEntity>(
  entities: T[],
  t: TFunction,
): ISelectMultiOption<string>[] {
  return entities.map(x => {
    return {
      value: x.id,
      label: t(`${x.name}`),
    };
  });
}

// Creates a single select option from a multi select option.
export function multiSelectToSingleSelect<T>(multiSelectOption: ISelectMultiOption<T>): ISelectOption<T> {
  if (multiSelectOption !== undefined) {
    return {
      value: multiSelectOption.value,
      label: multiSelectOption.label,
    } as ISelectOption<T>;
  }
  return {
    value: undefined,
    label: '',
  };
}

// Convents an array strings to an array of ISelectMultiOption
export function listOfStringsToMultiSelectOptions(items: string[]): ISelectMultiOption<string>[] {
  if (!items || items?.length < 1) {
    return;
  }
  return items.map(x => {
    return {
      value: x,
      label: x,
    };
  });
}

// Convents an array of ISelectMultiOption to an array strings
export function multiSelectOptionsToListOfStrings(items: ISelectMultiOption<string>[]): string[] {
  if (!items || items?.length < 1) {
    return;
  }
  return items?.map(x => x.value);
}
